<template>
  <div class="portada-xv" ref="rootRef" aria-label="Portada de XV">

    <!-- FLORES DECORATIVAS -->
    <img src="@/assets/f.png" class="flor flor-1" alt="" />
    <img src="@/assets/f.png" class="flor flor-2" alt="" />
    <img src="@/assets/f.png" class="flor flor-3" alt="" />

    <!-- 🌿 RAMAS MAGICAS -->
    <img src="@/assets/ramas.png" class="rama rama-izq" alt="" />
    <img src="@/assets/ramas.png" class="rama rama-der" alt="" />
<!-- 🌿 RAMA EXTRA PARA ARCO -->
<img src="@/assets/ramas.png" class="rama rama-der-baja" alt="" />


<!-- 🦋 MARIPOSAS MAGICAS -->
<img src="@/assets/mariposas.png" class="mariposa mariposa-1" alt="" />
<img src="@/assets/mariposas.png" class="mariposa mariposa-2" alt="" />
<img src="@/assets/mariposas.png" class="mariposa mariposa-3" alt="" />
<img src="@/assets/mariposas.png" class="mariposa mariposa-4" alt="" />

    <!-- BOLA DISCO GIRANDO -->
    <img src="@/assets/f.png" class="bola bola-izquierda" alt="" />
<img src="@/assets/ramas.png" class="rama rama-der-baja2" alt="" />
<img src="@/assets/ramas.png" class="rama rama-der-baja3" alt="" />

    <!-- IMAGEN CON RECORTE -->
    <div class="imagen-xv-wrapper">
      <img src="@/assets/IMG_1144.webp" class="imagen-xv" alt="Foto protagonista" />
    </div>

    <!-- LOGO 
    <img src="@/assets/logito.png" class="logo-portada" alt="Logo Yasmin" />
-->
    <!-- TEXTO -->
    <section class="texto-xv">
      <p class="frase-bendicion">
        Con la bendición de Dios <br />
        y de mis padres
      </p>

      <div class="separador-elegante"></div>

      <h1 class="nombre-protagonista">Alejandro Purata Ramírez</h1>
      <h1 class="nombre-protagonista">Wendy Olguin Rojas</h1>

      <p class="parrafo-presentacion">
        Hay momentos que definen nuestra vida, quedando grabados en el alma y la memoria.
        Hoy experimento uno de esos instantes especiales y quiero compartirlo con quienes
        tienen un lugar en mi corazón.
      </p>
    </section>
  </div>
</template>

<script>
import { onMounted, ref, nextTick } from 'vue'
import gsap from 'gsap'

export default {
  name: 'PortadaArley',
  setup() {
    const rootRef = ref(null)

    onMounted(async () => {
      await nextTick()

      const $ = (sel) => Array.from(gsap.utils.toArray(sel)).filter(Boolean)

      const foto = $('.imagen-xv-wrapper')
      const flores = ['.flor-1', '.flor-2', '.flor-3'].flatMap($)
const ramas = [
  '.rama-izq',
  '.rama-der',
  '.rama-der-baja',
    '.rama-der-baja3',

  '.rama-der-baja2'
].flatMap($)

const mariposas = [
  '.mariposa-1',
  '.mariposa-2',
  '.mariposa-3',
  '.mariposa-4'
].flatMap($)

      const texto = [
        '.frase-bendicion',
        '.separador-elegante',
        '.nombre-protagonista',
        '.parrafo-presentacion'
      ].flatMap($)

      // Estado inicial
      gsap.set([...foto, ...flores, ...texto], { autoAlpha: 0, y: 28 })

gsap.set(mariposas, {
  autoAlpha: 0,
  scale: 0.6,
  y: 40,
  filter: 'blur(1px)'
})


      gsap.set(ramas, {
        autoAlpha: 0,
        scaleY: 0,
        transformOrigin: 'top center',
        filter: 'blur(2px)'
      })

      // Observer
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (!e.isIntersecting) return

          const tl = gsap.timeline({ defaults: { ease: 'power2.out' } })

          // FOTO
          tl.fromTo(
            foto,
            { scale: 0.94, y: 40, filter: 'blur(6px)' },
            { autoAlpha: 1, scale: 1, y: 0, filter: 'blur(0px)', duration: 1.15 }
          )

          // FLORES
          tl.to(
            flores,
            { autoAlpha: 1, y: 0, duration: 0.9, stagger: 0.12 },
            '-=0.55'
          )


          // 🦋 MARIPOSAS emergiendo desde abajo de la foto
tl.to(
  mariposas,
  {
    autoAlpha: 1,
    y: 0,
    scale: 1,
    filter: 'blur(0px)',
    duration: 0.6,      // ⏱ más rápido
    stagger: 0.12,      // ⏱ menos espera entre ellas
    ease: 'power2.out'
  },
  '-=0.7'               // 👈 entran casi junto con flores
)

          // 🌿 RAMAS DIBUJADAS
        tl.to(
  ramas,
  {
    autoAlpha: 1,
    scaleY: 1,
    filter: 'blur(0px)',
    duration: 0.8,     // ⏱ más rápido
    stagger: 0.15,     // ⏱ menos delay
    ease: 'power2.out'
  },
  '-=0.6'              // 👈 aparecen antes
)

          // TEXTO
          tl.to(texto, { autoAlpha: 1, y: 0, duration: 0.8, stagger: 0.15 }, '-=0.25')

          // Movimiento orgánico
          ramas.forEach((r, i) => {
            gsap.to(r, {
              y: i === 0 ? '+=14' : '-=14',
              duration: 3.5,
              yoyo: true,
              repeat: -1,
              ease: 'sine.inOut'
            })
          })

          io.disconnect()
        })
      }, { threshold: 0.45 })

      if (rootRef.value) io.observe(rootRef.value)
    })

    return { rootRef }
  }
}
</script>


<style scoped>
.portada-xv{
  position: relative;
  width: 100%;
  min-height: 100vh;


  /* 🔒 Fixed solo funciona bien en desktop */

  overflow: visible;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;

  padding: 48px 16px 56px;
}
@media (max-width: 768px){
  .portada-xv{
    background-attachment: scroll;
  }
}


/* Marco con recorte superior redondeado (look luxury) */
.imagen-xv-wrapper{
  width: min(92vw, 360px);
  height: calc(min(92vw, 360px) * 1.5);
  margin-top: 6px;
  border-radius: 180px 180px 0 0;
  overflow: hidden;
  z-index: 2;
  background:#fff;
  box-shadow:
    0 12px 40px rgba(0,0,0,.18),
    0 2px 8px rgba(0,0,0,.06);
  will-change: transform, filter, opacity;
}
.imagen-xv{
  width:100%;
  height:100%;
  object-fit:cover;
  display:block;
}

/* LOGO CENTRADO */
.logo-portada{
  margin-top: 18px;
  max-width: 140px;
  width: 40vw;
  height: auto;
  display: block;
  margin-left: auto;
  margin-right: auto;
}

/* Texto */
.texto-xv{
  max-width: 620px;
  text-align:center;
  margin-top: 22px;
  padding: 0 8px;
}
.frase-bendicion{
  font-family: "Playfair Display", serif;
  font-size: clamp(18px, 2.6vw, 24px);
  color:#2f2e2e;
  line-height:1.5;
  margin: 20px 0 10px;
}
.separador-elegante{
  width:110px;
  height:2px;
  margin:12px auto 16px;
  background: linear-gradient(90deg, transparent, #d9b7c6, transparent);
  border-radius: 2px;
}
.nombre-protagonista{
  font-family: "titulos", cursive;
  font-size: 49px;
  color:#6b7c6d;
  margin: 0 0 8px 0;
  line-height:1.1;
}
.parrafo-presentacion{
  font-family: "quote", sans-serif;
  font-size: clamp(14px, 2.6vw, 16px);
  color:#3d3c3c;
  line-height:1.7;
  margin-top: 6px;
}

/* FLORES */
.flor{
  position:absolute;
  width:min(44vw, 240px);
  z-index:4; /* IMPORTANTE: bájalas del 10 */
  transform-origin:center;
  will-change: transform, opacity;

  opacity: 0.45;
  filter: blur(0.5px) saturate(0.75) brightness(1.05);
  mix-blend-mode: normal; /* 👈 CLAVE */
  pointer-events: none;
}

.flor-1{
  top:0px;
  left:-70px;
  z-index:1;
  width:min(54vw, 240px);
  transform: scaleX(-1) rotate(50deg) !important;
  opacity: 0.28;
}

.flor-2{
  top:30px;
  right:-80px;
  z-index:1;
  width:min(60vw, 340px);
  transform: scaleX(-1) rotate(150deg) !important;
  opacity: 0.22;
}

.flor-3{
  bottom:-50px;
  left:-90px;
  z-index:2;
  transform: rotate(-130deg);
  opacity: 0.35;
}

/* BOLA DISCO */
.bola{
  position:absolute;
  width:180px;
  animation: girar 10s linear infinite;
  opacity:.85;
  z-index:1;
  will-change: transform;
}
.bola-izquierda{ left:310px; bottom:-100px; z-index:9;}
@keyframes girar {
  0% {
    transform: scale(1);
    opacity: 0.9;
  }
  50% {
    transform: scale(1.1);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 0.9;
  }
}

/* 🌿 RAMAS MAGICAS */
.rama{
  position: absolute;
  width: min(28vw, 180px);
  opacity: 0.45;
  pointer-events: none;
  z-index: 0;
  filter: blur(1.5px) saturate(0.7);
  mix-blend-mode: multiply;
}
.rama{
  height: auto;
  max-height: 720px !important; /* permite que visualmente lleguen más abajo */
}

.rama-izq{
  top: 160px;
  left: -30px;
  transform: rotate(-6deg);
}

.rama-der{
  top: 160px;
  right: -30px;
  transform: scaleX(-1) rotate(-6deg);
}
.rama-der-baja{
  top: 220px;              /* empieza un poco más abajo */
  right: -30px;
  width: min(30vw, 210px); /* un poco más larga */
  transform: rotate(12deg);
  opacity: 0.38;
}

.rama-der-baja2{
  top: 420px;              /* empieza un poco más abajo */
  right: -30px;
  width: min(30vw, 210px); /* un poco más larga */
  transform: rotate(12deg);
  opacity: 0.38;
}
.rama-der-baja3{
  top: 620px;              /* empieza un poco más abajo */
  right: -80px;
  width: min(30vw, 210px); /* un poco más larga */
  transform: rotate(12deg);
  opacity: 0.38;
}

/* Responsive refinado */
@media (min-width: 992px){
  .portada-xv{ padding-top:64px; }
  .imagen-xv-wrapper{ margin-top: 0; }
}


/* 🦋 MARIPOSAS MAGICAS */
.mariposa{
  position: absolute;
  width: min(16vw, 110px);
  opacity: 0.7;
  pointer-events: none;

  /* 👇 CLAVES */
  z-index: 3;                 /* visible pero debajo del marco */
  filter: blur(0.3px);
  mix-blend-mode: normal;     /* 🔥 QUITA soft-light */
}


/* Posiciones pensadas para espacios libres */
.mariposa-1{
  left: 10%;
  top: 0%;
}

.mariposa-2{
  right: 12%;
  top: -2%;
}

.mariposa-3{
  left: 18%;
  top: 2%;
}

.mariposa-4{
  right: 20%;
  top: 8%;
}

/* Mobile: más sutil */
@media (max-width: 768px){
  .mariposa{
    opacity: 0.35;
    width: min(18vw, 80px);
  }
}

</style>
